import { IBitfApiCallState } from '@interfaces';
import { BitfStrapiApiCallStateMapper } from '@common/libs/bitforce/core/api-call-state/bitf-strapi-api-call-state';

export class DefaultApiCallStateMapper extends BitfStrapiApiCallStateMapper {
  buildApiRequest(apiCallState: IBitfApiCallState): void {
    super.buildApiRequest(apiCallState);
  }
}
